import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD,
    ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD_BY_ID,

    ACTION_PROJECTITEMTEMPLATECATEGORY_SAVE,

    ACTION_PROJECTITEMTEMPLATECATEGORY_CREATE,

    ACTION_PROJECTITEMTEMPLATECATEGORY_VALIDATE,

    IProjectItemTemplateCategoryLoadAction,
    IProjectItemTemplateCategoryLoadByIdAction,
    IProjectItemTemplateCategoryLoadFailureAction,
    IProjectItemTemplateCategoryLoadSuccessAction,

    IProjectItemTemplateCategorySaveAction,
    IProjectItemTemplateCategorySaveSuccessAction,
    IProjectItemTemplateCategorySaveFailureAction,

    IProjectItemTemplateCategoryCreateAction,
    IProjectItemTemplateCategoryCreateSuccessAction,
    IProjectItemTemplateCategoryCreateFailureAction,

    IProjectItemTemplateCategoryValidateAction,
    IProjectItemTemplateCategoryValidateSuccessAction,
    IProjectItemTemplateCategoryValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/projectItemTemplateCategory";
import { projectItemTemplateCategorysApi } from "../services/projectItemTemplateCategory";

export const
    getProjectItemTemplateCategorysEpic = (action$): Observable<IProjectItemTemplateCategoryLoadSuccessAction | IProjectItemTemplateCategoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD)
            .mergeMap((_action: IProjectItemTemplateCategoryLoadAction) => {
                return projectItemTemplateCategorysApi
                    .getProjectItemTemplateCategorys()
                    .map(response =>
                        LoadSuccess(response.projectItemTemplateCategorys, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getProjectItemTemplateCategoryByIdEpic = (action$): Observable<IProjectItemTemplateCategoryLoadSuccessAction | IProjectItemTemplateCategoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD_BY_ID)
            .mergeMap((action: IProjectItemTemplateCategoryLoadByIdAction) => {
                return projectItemTemplateCategorysApi
                    .getProjectItemTemplateCategoryById(action.id)
                    .map(response =>
                        LoadSuccess(response.projectItemTemplateCategory, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setProjectItemTemplateCategoryEpic = (action$): Observable<IProjectItemTemplateCategorySaveSuccessAction | IProjectItemTemplateCategorySaveFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTITEMTEMPLATECATEGORY_SAVE)
            .mergeMap((action: IProjectItemTemplateCategorySaveAction) => {
                return projectItemTemplateCategorysApi
                    .setProjectItemTemplateCategory(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.projectItemTemplateCategory, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createProjectItemTemplateCategoryEpic = (action$): Observable<IProjectItemTemplateCategoryCreateSuccessAction | IProjectItemTemplateCategoryCreateFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTITEMTEMPLATECATEGORY_CREATE)
            .mergeMap((_action: IProjectItemTemplateCategoryCreateAction) => {
                return projectItemTemplateCategorysApi
                    .createProjectItemTemplateCategory()
                    .map(response =>
                        CreateSuccess(
                            response.projectItemTemplateCategory,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateProjectItemTemplateCategoryEpic = (action$): Observable<IProjectItemTemplateCategoryValidateSuccessAction | IProjectItemTemplateCategoryValidateFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTITEMTEMPLATECATEGORY_VALIDATE)
            .mergeMap((action: IProjectItemTemplateCategoryValidateAction) => {
                return projectItemTemplateCategorysApi
                    .validateProjectItemTemplateCategory(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.projectItemTemplateCategory, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }



